import { DEFAULT_TASK_STATES } from "constants/defaultTaskState";
import { TaskCategoryType, TaskDeadlineState } from "types/Models/task";

const {
  PAYMENT,
  FORM_FILING,
  FILING_IN_PROGRESS,
  SUBMITTED,
  TASK_AMENDMENT,
  TASK_AMENDMENT_COMPLETED,
} = DEFAULT_TASK_STATES;

export const getTaskStatesFromTaskCategory = (
  taskCategoryType: TaskCategoryType
): TaskDeadlineState[] => {
  switch (taskCategoryType) {
    case "BOOKS":
      return [PAYMENT, FILING_IN_PROGRESS, SUBMITTED];

    default:
      return [PAYMENT, FORM_FILING, FILING_IN_PROGRESS, SUBMITTED];
  }
};
